<template>
	<div class="vx-col w-full mb-base" ref="popupContainer">
		<vs-popup
			fullscreen
			:active.sync="showAllCommandePopup"
			title="Toutes les commandes"
			style="z-index: 52999"
		>
			<AllOrderPopup />
		</vs-popup>
		<FilterCard
			:isGestion="true"
			:filters="filtersTemplates"
			:showListLength="listContracts.length"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>
		<vx-card style="max-height: 79vh; overflow: auto">
			<div v-if="isLoadingData">
				<circular-loader />
			</div>
			<div v-else>
				<GestionConsultantsTable
					@getData="transData()"
					:refreshKey="refreshKey"
					:selectedDate="dateFilter"
					:contracts="listContracts"
					@refresh-data="getAllAccountManagerContracts()"
					@delete-line="removeLine($event)"
					@modify-contract="modifyContract($event)"
					@display-contract="displayContractPopup($event)"
					@display-documents="displayDocumentPopup($event)"
				/>
			</div>
		</vx-card>
	</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import store from "@/store/store";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin.js";
import GestionConsultantsTable from "@/components/tables/GestionConsultantsTable";
import FilterCard from "@/views/filters/FilterCard";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import VueCookies from "vue-cookies";
import AllOrderPopup from "../../components/popups/AllOrderPopup.vue";
import CircularLoader from "../../components/widgets/loader/CircularLoader.vue";
import AllBacklinksPopupup from "../../components/popups/AllBacklinksPopupup.vue";
import BacklinksManagementPopup from "../../components/popups/BacklinksManagementPopup.vue";
import NetlinksBoughtPopup from "../../components/popups/NetlinksBoughtPopup.vue";

export default {
	name: "ConsultantsDashboard",
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		AllOrderPopup,
		FilterCard,
		GestionConsultantsTable,
		CircularLoader,
		BacklinksManagementPopup,
		AllBacklinksPopupup,
		NetlinksBoughtPopup,
	},
	data() {
		return {
			isLoadingData: false,
			refreshList: [],
			allContracts: [],
			listContracts: [],
			accountmanagerFilter: null,
			contractNumberFilter: null,
			societyFilter: null,
			statusFilter: [],
			typeFilter: "",
			isShowAll: false,
			accountmanagerOptions: [],
			showAllCommandePopup: false,
			contractStatusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "A\u00a0Valider", value: 2 },
				{ text: "En\u00a0pause", value: 3 },
				{ text: "Terminé", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			typeOptions: [
				{ text: "SEO", value: 1 },
				{ text: "SEA", value: 2 },
				{ text: "E-Réputation", value: 3 },
				{ text: "Social Ads", value: 4 },
				{ text: "RP Digitale", value: 5 },
				{ text: "Formation", value: 6 },
				{ text: "Autre", value: 7 },
				{ text: "Content", value: 8 },
			],
			apiUrl: this.$store.state.backendApiUrl,
			dateFilter: null,

			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			actionsTemplates: [
				{
					order: 1,
					emitSlugName: "show_orders",
					buttonName: "Toutes les commandes",
					buttonIcon: "",
					buttonColor: "dark",
				},
				{
					order: 1,
					emitSlugName: "show_backlinks",
					buttonName: "Backlinks",
					buttonIcon: "icon-link",
					buttonColor: "dark",
				},
				{
					order: 1,
					emitSlugName: "show_backlinks_management",
					buttonName: "Gestion Netlinking",
					buttonIcon: "icon-grid",
					buttonColor: "dark",
				},
				/*
				 * The previous budget popup, kept alongside the new one so the two
				 * calculations can be compared. It reads netlinks_budget_sheet, the
				 * new one recomputes everything on read, so they will disagree
				 * wherever a stored row is stale.
				 */
				// {
				// 	order: 1,
				// 	emitSlugName: "show_backlinks_management_old",
				// 	buttonName: "Gestion Netlinking_old",
				// 	buttonIcon: "icon-archive",
				// 	buttonColor: "dark",
				// },
			],
			filtersTemplates: [
				{
					order: 2, // Filter order compared to others
					emitSlugName: "filter_contract",
					filterPlaceHolder: "N° de Contrat",
					value: "", // Consultant id
					type: "Input",
				},
				{
					order: 3,
					emitSlugName: "filter_client",
					filterPlaceHolder: "Client",
					value: "",
					type: "Input",
				},
				{
					order: 4,
					emitSlugName: "filter_type",
					filterPlaceHolder: "Type",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [
							{ name: "SEO", id: 1 },
							{ name: "SEA", id: 2 },
							{ name: "E-Réputation", id: 3 },
							{ name: "Social Ads", id: 4 },
							{ name: "RP Digitale", id: 5 },
							{ name: "Formation", id: 6 },
							{ name: "Autre", id: 7 },
						],
					},
				},
				{
					order: 5,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut (Sélection multiple)",
					value: [0],
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: true,
						dropdownValues: [
							{ name: "Actif", id: 1 },
							{ name: "A\u00a0Valider", id: 2 },
							{ name: "En\u00a0pause", id: 3 },
							{ name: "Terminé", id: 4 },
							{ name: "Annulé", id: 5 },
						],
					},
				},
				{
					order: 1,
					emitSlugName: "filter_consultant",
					filterPlaceHolder: "Consultant",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 6,
					emitSlugName: "filter_period",
					filterPlaceHolder: "Période",
					value: "",
					require: true,
					type: "Date",
					params: {
						date_type: "period",
					},
				},
				{
					order: 7,
					emitSlugName: "filter_isDone",
					filterPlaceHolder: "",
					value: false,
					type: "Switch",
					params: {
						on: "Tous",
						off: "A faire",
					},
				},
			],
			refreshKey: 0,
			reDate: 0,
			taskTotal: 0,
			taskTotalDone: 0,
			currentTab: 0,
			totalPage: 0,
			currentx: 1,
			// axios
			cancelTokenSource: null,
		};
	},

	created() {
		let today = new Date(Date.now());
		this.$store.dispatch("getAllCollaborators");
		if (this.$route.query.period) {
			this.dateFilter = this.$route.query.period;
		} else {
			this.dateFilter = `${today.getMonth() + 1}/${today.getFullYear()}`;
		}
		if (this.$route.query.backlinks) {
				this.displayBacklinksPopup()
		}

		this.filtersTemplates[5].value = this.dateFilter;
		this.filtersTemplates[4].value = [VueCookies.get("userInfo").id];
		this.accountmanagerFilter = [VueCookies.get("userInfo").id];
	},
	mounted() {
		if (this.allCollaborators.length > 0) this.createAMList();
	},
	watch: {
		accountmanagerFilter: async function () {
			await this.getAllAccountManagerContracts(true);
		},
		allCollaborators: function (data) {
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId) {
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					data
						.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
		},
		contractNumberFilter: async function () {
			await this.getAllAccountManagerContracts();
		},
		dateFilter: async function () {
			await this.getAllAccountManagerContracts(true);
		},
		isShowAll: async function () {
			await this.getAllAccountManagerContracts(true);
		},
		societyFilter: async function () {
			await this.getAllAccountManagerContracts();
		},
		statusFilter: async function () {
			await this.getAllAccountManagerContracts();
		},
		typeFilter: async function () {
			await this.getAllAccountManagerContracts();
		},
		currentTab: function () {
			this.refreshKey++;
		},
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		societies: () => {
			return store.state.societies;
		},
	},
	methods: {
		async resetAllFilter() {
			this.accountmanagerFilter = null;
			this.contractNumberFilter = null;
			this.societyFilter = null;
			this.statusFilter = [];
			this.typeFilter = "";
			this.isShowAll = false;
			this.accountmanagerOptions = [];

			// Query Check
			let today = new Date(Date.now());
			if (this.$route.query.period) {
				this.dateFilter = this.$route.query.period;
			} else {
				this.dateFilter = `${today.getMonth() + 1}/${today.getFullYear()}`;
			}

			this.filtersTemplates[5].value = this.dateFilter;
			this.filtersTemplates[4].value = "";
			this.accountmanagerFilter = "";
			this.$store.dispatch("getAllCollaborators");

			this.allContracts = JSON.parse(JSON.stringify(this.refreshList));
		},
		createAMList() {
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId)
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					this.sortABC(
						this.allCollaborators.filter((collaborator) =>
							[3, 6, 9].includes(collaborator.type)
						),
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
		},

		transData() {
			this.filterContract(this.allContracts);
		},

		async filterContract(contract) {
			try {
				let temporay = contract;
				let tmpList = temporay;
				// if(this.dateFilter) tmpList = tmpList = tmpList.filter(contract => contract.society_name.toLowerCase().indexOf(this.societyFilter.toLowerCase()) > -1);
				if (this.societyFilter != null)
					tmpList = tmpList.filter(
						(contract) =>
							contract.society_name
								.toLowerCase()
								.indexOf(this.societyFilter.toLowerCase()) > -1
					);
				if (this.contractNumberFilter)
					tmpList = tmpList.filter(
						(contract) =>
							contract.contract_id
								.toString()
								.indexOf(this.contractNumberFilter) > -1
					);
				if (this.typeFilter > 0)
					tmpList = tmpList.filter(
						(contract) => contract.type_id == this.typeFilter
					);
				if (this.statusFilter.length > 0) {
					tmpList = tmpList.filter(
						(contract) =>
							this.statusFilter.indexOf(contract.contract_status) > -1
					);
				}

				// if (!this.isShowAll) {
				// 	tmpList = tmpList.filter((item) =>
				// 		item.missions_list.some((mission) => mission.task_archived === 0)
				// 	);
				// }
				this.taskTotal = tmpList.reduce(
					(sum, e) => sum + Number(e.total_tasks || 0),
					0
				);
				this.taskTotalDone = tmpList.reduce(
					(sum, e) => sum + Number(e.tasks_done || 0),
					0
				);
				this.listContracts = tmpList;
				this.refreshKey++;
			} catch (err) {
				console.log(err);
			}
		},
		async getAllAccountManagerContracts(run = false) {
			try {
				this.isLoadingData = true;
				let allRun = 0;
				if (run) {
					//if params assign automatically the contract id
					let runApi;
					let month = "";
					let year = "";
					let tmp = this.dateFilter
						? this.dateFilter.substring(0, 7).split("/")
						: null;
					if (Boolean(this.isShowAll)) {
						allRun = 1;
					}
					if (tmp) {
						month = tmp[0].length == 1 ? `0${tmp[0]}` : tmp[0] || null;
						year = tmp[1] || null;
					}
					runApi =
						this.apiUrl +
						"account_manager_view/all?year=" +
						year +
						"&month=" +
						month +
						"&consultant=" +
						this.accountmanagerFilter +
						"&page=" +
						this.currentx +
						"&limit=100" +
						"&all=" +
						allRun;

					if (this.cancelTokenSource) {
						this.cancelTokenSource.cancel(
							"Operation canceled due to new request."
						);
					}
					// Create a new cancel token for the new request
					this.cancelTokenSource = axios.CancelToken.source();
					await axios
						.get(runApi, {
							cancelToken: this.cancelTokenSource.token,
						})
						.then(async (res) => {
							this.refreshList = res.data;
							this.allContracts = res.data;
							// this.reDate++;
							await this.filterContract(this.allContracts);
							this.refreshKey++;
							this.isLoadingData = false;
							this.cancelTokenSource = null;
						})
						.catch((err) => {
							if (axios.isCancel(err)) {
								console.log("Request canceled:", err.message);
							} else {
								console.error("Request failed:", err);
								this.isLoadingData = false;
							}
						});
				} else {
					this.reDate++;
					this.filterContract(this.allContracts);
					this.isLoadingData = false;
				}
			} catch (err) {
				console.log(err);
			}
		},

		getBudgetTotalNetlinking() {
			if (this.listContracts) {
				return this.convertInternationalNumberToFrenchCurrency(
					this.listContracts.reduce(
						(sum, e) => sum + Number(e.total_max_budget_netlink || 0),
						0
					)
				);
			}
			return this.convertInternationalNumberToFrenchCurrency(0);
		},
		displayBacklinksPopup() {
			let ComponentClass = Vue.extend(AllBacklinksPopupup);
			let backlinksContractPopup = new ComponentClass({
				propsData: {
					popupActive: true,
				},
			});
			backlinksContractPopup.$mount();
			backlinksContractPopup.$on("on-import-netlink", () => {
				this.$router.push({ name: "import_netlinks" });
			});

			this.$refs.popupContainer.appendChild(backlinksContractPopup.$el);
		},
		/*
		 * "Afficher les contrats et budgets" - the previous popup, reading its
		 * figures from netlinks_budget_sheet. On the "Gestion Netlinking_old"
		 * button so its numbers can be compared against the live ones.
		 */
		displayBacklinksManagementPopup() {
			let ComponentClass = Vue.extend(BacklinksManagementPopup);
			let backlinksContractPopup = new ComponentClass({
				propsData: {
					popupActive: true,
				},
			});
			backlinksContractPopup.$mount();
			backlinksContractPopup.$on("on-import-netlink", () => {
				this.$router.push({ name: "import_netlinks" });
			});

			this.$refs.popupContainer.appendChild(backlinksContractPopup.$el);
		},

		displayNetlinksBoughtPopup() {
			let ComponentClass = Vue.extend(NetlinksBoughtPopup);
			let netlinksBoughtPopup = new ComponentClass({
				propsData: {
					popupActive: true,
				},
			});
			netlinksBoughtPopup.$mount();

			this.$refs.popupContainer.appendChild(netlinksBoughtPopup.$el);
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			console.log(receivedEmit[0]);
			switch (receivedEmit[0]) {
				case "filter_client":
					this.societyFilter = receivedEmit[1].value;
					break;
				case "filter_contract":
					this.contractNumberFilter = receivedEmit[1].value;
					break;
				case "filter_period":
					this.dateFilter = receivedEmit[1].value;
					break;
				case "filter_type":
					this.typeFilter = receivedEmit[1].value;
					break;
				case "filter_status":
					this.statusFilter = receivedEmit[1].value;
					break;
				case "filter_consultant":
					this.accountmanagerFilter = [receivedEmit[1].value];
					break;
				case "filter_isDone":
					this.isShowAll = receivedEmit[1].value;
					break;
				case "search_button":
					this.getAllAccountManagerContracts(true);
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			switch (receivedEmit[0]) {
				case "show_orders":
					this.showAllCommandePopup = true;
					break;
				case "onsearch":
					this.getAllAccountManagerContracts();
					break;
				case "show_backlinks":
					this.displayBacklinksPopup();
					break;
				case "show_backlinks_management":
					// The live budget popup
					this.displayNetlinksBoughtPopup();
					break;
				case "show_backlinks_management_old":
					// The previous one, reading netlinks_budget_sheet
					this.displayBacklinksManagementPopup();
					break;
				default:
					break;
			}
		},
	},
};
</script>

<style lang="scss">
.center {
	justify-content: center;
}
.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
</style>
